<template>
  <page>
    <v-container fluid grid-list-md>
    <div :load="doInit">
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                <v-flex xs6>
                  <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" v-validate="fromDateValidation(reportForm.tranDateTo)" :data-vv-as="labels.tranDateFrom" data-vv-name="tranDateFrom" :error-messages="errors.collect('tranDateFrom')" :min="fromDateMinDate" :max="fromDateMax()"></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" v-validate="toDateValidation(reportForm.tranDateFrom)" :data-vv-as="labels.tranDateTo" data-vv-name="tranDateTo" :error-messages="errors.collect('tranDateTo')" :min="reportForm.tranDateFrom" :max="fromDateMax()"></cal-picker>
                </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-spacer class="mt-2"></v-spacer>
      <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                <!-- Branch -->
                <v-flex xs12 sm12 md12 lg12>
                  <v-text-field v-model="reportForm.branch" :label="labels.branch" :error-messages="errors.collect('branch')"
                  :data-vv-as="labels.branch" data-vv-name="branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" readonly
                  v-validate="'required'"></v-text-field>
                </v-flex>
                <!-- Business Class -->
                <v-flex xs12 sm12 md12 lg12>
                  <v-text-field v-model="reportForm.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')"
                  :data-vv-as="labels.busCls" data-vv-name="busCls" append-icon="mdi-magnify" @click:append="getHelpList('busCls')" readonly
                  v-validate="'required'"></v-text-field>
                </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-spacer class="mt-2"></v-spacer>
      <v-form>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex lg12 xs12>
              <v-checkbox v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
            </v-flex>
            <v-flex>
            <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
      <v-dialog v-model="branchList" width="900px" persistent>
        <multi-branch-help-list :brn="reportForm.branch" @close="doClose" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
      </v-dialog>
      <v-dialog v-model="busClsList" width="900px" persistent>
        <multi-bus-cls-help-list :busCls="reportForm.busCls" @close="doClose" @doAssign="doAssignBusCls($event)"></multi-bus-cls-help-list>
      </v-dialog>
      </v-container>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Ranges',
        tranDateFrom: 'New Claim Period From*',
        tranDateTo: 'New Claim Period To*',
        branch: 'Branch',
        busCls: 'Business Class',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        tranDateFrom: undefined,
        tranDateTo: new Date(),
        branch: 'All',
        busCls: 'All',
        format: undefined,
        printRptRunTime: true
      },
      // HelpList
      branchList: false,
      busClsList: false,
      // Other
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      supportedFormat: [],
      loading: false,
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.rptMenu.claimwoReserves
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.doneInitialization = true
      } catch (err) {
        throw err
      }
    },
    doAssignBusCls(Obj) {
      this.reportForm.busCls = []
      this.reportForm.busCls = Obj.finalSelectedItems.toString()
    },
    async doAssignBranch(Obj) {
      this.reportForm.branch = []
      this.reportForm.branch = Obj.finalSelectedItems.toString()
    },
    doClose() {
      this.branchList = false
      this.busClsList = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    getHelpList(data) {
      if (data === 'branch') {
        this.branchList = true
        this.busClsList = false
      } else {
        this.branchList = false
        this.busClsList = true
      }
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateMax() {
      return new Date(2070, 11, 31)
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    MultiBranchHelpList,
    MultiBusClsHelpList
  }
}
</script>
